var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("dutyImport")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.importing
                ? _c(
                    "div",
                    [
                      _c("CenterOnParent", [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-row align-items-center" },
                          [
                            _c("Spinner", { staticClass: "mr-2" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("duty.importing")) +
                                "\n            "
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._l(_vm.templates, function(template) {
                    return _c(
                      "div",
                      { key: template.internalId, staticClass: "form-check" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selected,
                              expression: "selected"
                            }
                          ],
                          ref: "checkbox",
                          refInFor: true,
                          staticClass: "form-check-input",
                          attrs: {
                            id: "cb_" + template.internalId,
                            type: "checkbox"
                          },
                          domProps: {
                            value: template,
                            checked: Array.isArray(_vm.selected)
                              ? _vm._i(_vm.selected, template) > -1
                              : _vm.selected
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.selected,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = template,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.selected = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.selected = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.selected = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "cb_" + template.internalId }
                          },
                          [_vm._v(_vm._s(template.name))]
                        )
                      ]
                    )
                  })
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", disabled: _vm.importing },
                on: { click: _vm.dismiss }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("btnCancel")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button", disabled: _vm.importing },
                on: { click: _vm.importTemplates }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("dutyImport")) + "\n        "
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }